import {
  formatToDecimal,
  formatToEurosCurrency,
  formatToPercent,
  formatToTwoDecimalPlaces,
} from "../../../../../../shared/lib/utils";
import PrimaryKpis from "./PrimaryKpis";
import SecondaryKpis from "./SecondaryKpis";

const Kpis = ({ kpis }) => {
  return (
    <div className="flex flex-row justify-between gap-x-4 min-h-[20vh] max-h-[20vh]">
      <PrimaryKpis
        investment={formatToEurosCurrency(kpis?.investment)}
        impressions={formatToDecimal(kpis?.impressions)}
        conversions={formatToTwoDecimalPlaces(kpis?.conversions)}
        revenue={formatToEurosCurrency(kpis?.revenue)}
      />
      <SecondaryKpis
        ctr={formatToPercent(kpis?.ctr)}
        sessions={formatToDecimal(kpis?.sessions)}
        bouncesRatio={formatToPercent(kpis?.bouncesRatio)}
        newUsers={formatToDecimal(kpis?.newUsers)}
        roas={formatToTwoDecimalPlaces(kpis?.roas)}
      />
    </div>
  );
};

export default Kpis;
